import React, { Fragment } from 'react'

export default function CredentialForm () {
  return (
    <><div className='pscreen-section pscreen-section--official'>
          <div className='section-header section-header--assessor'>
              <h2>Section B: Credentials Screening by PSC Assessor </h2>
              <span className='section-badge'>Assessor Only</span>
          </div>

          <p className='section-note'>Enter A = Pass or B = Fail</p>

          <table className='credentials-table'>
              <tbody>
                  <tr>
                      <td className='credentials-table__label '>English Language:</td>
                      <td className='credentials-table__field '></td>

                      <td className='credentials-table__label'>Birth Certificate/Declaration:</td>
                      <td className='credentials-table__field'></td>
                  </tr>

                  {/* Guarantors Form and Valid NIN Printout */}
                  <tr>
                      <td className='credentials-table__label'>Mathematics :</td>
                      <td className='credentials-table__field '></td>

                      <td className='credentials-table__label'>Guarantors Form:</td>
                      <td className='credentials-table__field'></td>

                  </tr>

                  {/* Birth Certificate and LGA/State Certificate */}
                  <tr>
                      <td className='credentials-table__label '> Subject 3</td>
                      <td className='credentials-table__field '></td>

                      <td className='credentials-table__label'>LGA/State Certificate:</td>
                      <td className='credentials-table__field'></td>

                  </tr>
                  {/* English and Mathematics */}
                  <tr>
                      <td className='credentials-table__label '> Subject 4</td>
                      <td className='credentials-table__field '></td>
                      <td className='credentials-table__label'>Trade Test (Specialists):</td>
                      <td className='credentials-table__field'></td>

                  </tr>

                  {/* Subject 3 and Subject 4 */}
                  <tr>

                      <td className='credentials-table__label '> Subject 5 </td>
                      <td className='credentials-table__field '></td>
                      <td className='credentials-table__label'>Valid NIN Printout:</td>
                      <td className='credentials-table__field'></td>
                  </tr>
                  <tr>
                      <td className='credentials-table__label'>SSCE Certificate Year:</td>
                      <td className='credentials-table__field'></td>

                      <td className='credentials-table__label'>Alteration(s) on Certificates:</td>
                      <td className='credentials-table__field'></td>
                  </tr>

                  {/* Subject 5 and SSCE Certificate Year */}

                  {/* Comments */}
                  <tr>
                      <td className='credentials-table__label credentials-table__label--top' colSpan={4}>
                          Comments (especially if any faults/alterations):
                      </td>
                  </tr>
                  <tr>
                      <td className='credentials-table__field credentials-table__field--comments' colSpan={4}>
                          <div className='credentials-table__comment-lines my-2'>
                              <div className='my-4'></div>
                          </div>
                      </td>
                  </tr>

                  {/* Assessor Name and Signature */}
                  <tr>
                      <td className='credentials-table__label'>Name of Assessor:</td>
                      <td className='credentials-table__field'></td>
                      <td className='credentials-table__label'>Signature/Date:</td>
                      <td className='credentials-table__field'></td>
                  </tr>
              </tbody>
          </table>
      </div><div className='pscreen-section pscreen-section--official'>
              <div className='section-header section-header--teamlead'>
                  <h2>Section C: Final Endorsement by Team Lead</h2>
                  <span className='section-badge'>Official Only</span>
              </div>

              <p className='section-note'>
                  For official use only (A = Pass/Recommended, B = Fail/Not Recommended)
              </p>

              <div className='manual-form-grid'>
                  <div className='manual-row manual-row--wide d-flex'>
                      <label className='manual-label'>
                          (PSC TEAM LEAD) Name/Signature:
                      </label>
                      <div className='manual-line-long'></div>
                      <label className='manual-label ml-3'>Recommendation:</label>
                      <div className='manual-line-long '></div>
                  </div>

                  <div className='manual-row manual-row--full'>
                      <label className='manual-label'>Comments (if any):</label>
                      <div className='manual-multiline'>
                          <div className='manual-line my-3'></div>
                          {/* <div className='manual-line my-3'></div> */}
                      </div>
                  </div>

                  {/* <div className='manual-row'>
      <label className='manual-label'>Date:</label>
      <div className='manual-line'></div>
    </div> */}
              </div>
          </div></>
  )
}
